import { InjectionToken } from '@angular/core';

export const RLOTTIE_OPTIONS = new InjectionToken('RLOTTIE_OPTIONS');

export interface RlottieOptions {
  workersNum: number;
}

const defaultOptions: RlottieOptions = {
  workersNum: 4
};
export function provideRlottieOptions(options: RlottieOptions|null = null) {
  return {
    provide: RLOTTIE_OPTIONS,
    useValue: {
      ...defaultOptions,
      ...(options || {})
    }
  };
}